import { formatDate } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Observable, of } from 'rxjs';
import { delay, map, switchMap } from 'rxjs/operators';
import { IDataTableRowActionClickArg } from 'src/app/share/components/data-table-card/data-table-card.component';
import { IActionModel } from 'src/app/share/entities/data-model';
import { IDataPanelViewModel, IViewData } from 'src/app/share/entities/view-model';
import { FormInputComponent, IFormInputViewModel } from 'src/app/share/forms/form-input/form-input.component';
import { FormOkCancelComponent } from 'src/app/share/forms/form-ok-cancel/form-ok-cancel.component';
import { BasePageComponent, IBasePageOnInitArg, IDataPanelTabViewModel } from 'src/app/share/pages/base-page.component';
import { IPageContentFormViewModel, IPageContentViewModel, IPageDataViewModel, IPageViewModel } from 'src/app/share/pages/pages';
import { AuthService } from 'src/app/share/services/auth.service';
import { CommonService } from 'src/app/share/services/common.service';
import { ShellService } from 'src/app/shell/shell.service';

@Component({
  selector: 'app-chauffeur-emails',
  templateUrl: './chauffeur-emails.component.html',
  styleUrls: ['./chauffeur-emails.component.scss']
})
export class ChauffeurEmailsComponent extends BasePageComponent implements OnInit {

  private readonly apiPath: string = '/api/chauffeurs';
  searchData: string = '';

  constructor(private apiService: CommonService, protected shellService: ShellService, protected activatedRate: ActivatedRoute, private authService: AuthService) { 
    super(shellService, activatedRate);
  }

  /**
   * 
   * @param action 
   * @param paramData 
   * @returns 
   */
  private commandInvoke(action: string, paramData): Observable<IPageDataViewModel> {
    return this.apiService.getData('PageCommand', 'chauffeur-email', action, paramData, this.apiPath, true);
  }

  /**
   * 
   * @param pvm 
   * @param vm 
   */
  onPageAddNew(pvm: IPageViewModel, vm: IContentViewModel) {
    this.chauffeurEmailFormStart(undefined, pvm, 'new');
  }

  /**
   * 
   * @param pvm 
   * @param vm 
   */
  private async chauffeurEmailFormStart(data: string[], pvm: IPageViewModel, action: string) {
    const fvm = super.formBegin(pvm, this.chauffeurEmail(data, action));

    await super.formLoadAsync(fvm, () => {
      return of({}).pipe(
        delay(500) /* todo... implement work */
      );
    });
  }

  /**
   * 
   * @param vm 
   * @returns 
   */
  private chauffeurEmail(d: string[], action: string): IFormViewMomdel {
    const data = { 
      driverCode: !d || action == 'new' ? '' : d[0],
      driverFirstName: !d || action == 'new' ? '' : d[1],
      driverLastName: !d || action == 'new' ? '' : d[2],
      emailAddress: !d || action == 'new' ? '' : d[3]
    };

    const ret: IFormViewMomdel = {
      ...super.formVm('handle-upload', { okCancelOptions: {} }),

      title: 'Upload Driver Email',
      data: data,

      action: action,

      isValid: action == 'delete' ? true : false,

      message: action != 'delete' ? '' : `Are you sure you want to delete email for ${data.driverCode} - ${data.driverFirstName} ${data.driverLastName}`,

      driverCodeVm: FormInputComponent.viewModel(data, 'driverCode', { title: 'Chauffeur Code', type: 'text', isRequired: action == 'new' ? true : false, isLocked: action == 'new' ? false : true }),
      driverFirstNameVm: FormInputComponent.viewModel(data, 'driverFirstName', { title: 'Chauffeur First Name', type: 'text', isRequired: false, isLocked: true }),
      driverLastNameVm: FormInputComponent.viewModel(data, 'driverLastName', { title: 'Chauffeur Last Name', type: 'text', isRequired: false, isLocked: true }),
      emailInputVm: FormInputComponent.viewModel(data, 'emailAddress', { title: 'Email Address', type: 'text', isRequired: true })
    };
    return ret;
  }

  /**
   * 
   * @param pvm 
   * @param vm 
   * @param fvm 
   */
  chauffeurEmailFormValidate(pvm: IPageViewModel, vm: IContentViewModel, fvm: IFormViewMomdel) {
    const valids = [
      (fvm.data.driverCode ?? '').length > 0  ? true : false,
      (fvm.data.emailAddress ?? '').length > 0 && this.isEmail(fvm.data.emailAddress)  ? true : false
    ];
    fvm.isValid = valids.filter(v => !v).length == 0;
  }

  isEmail(email: string): boolean {
    const expression: RegExp = /^(?=.{1,254}$)(?=.{1,64}@)[-!#$%&'*+/0-9=?A-Z^_`a-z{|}~]+(\.[-!#$%&'*+/0-9=?A-Z^_`a-z{|}~]+)*@[A-Za-z0-9]([A-Za-z0-9-]{0,61}[A-Za-z0-9])?(\.[A-Za-z0-9]([A-Za-z0-9-]{0,61}[A-Za-z0-9])?)*$/;

    return expression.test(email);
  }

  /**
   * 
   * @param pvm 
   * @param vm 
   * @param fvm 
   */
  async chauffeurEmailFormOk(pvm: IPageViewModel, vm: IContentViewModel, fvm: IFormViewMomdel) {
    const success = await FormOkCancelComponent.processOkAsync(fvm.okCancelVm, 'Saving...',
      () => this.commandInvoke('chauffeur-email-save', { driverCode: fvm.data.driverCode, emailAddress: fvm.data.emailAddress, action: fvm.action, user: this.authService.userName() }));

    if (success)
      this.formEndRefresh(pvm);
  }

  ngOnInit(): void {
    super.onInit((arg: IBasePageOnInitArg) => {

      // user page
      return of({}).pipe(

        // load content VM
        switchMap(() => this.commandInvoke('page-load', {})),

        // return page VM
        map((d: IPageDataViewModel) => {
          if (d.workingText || d.errorText)
            return d;

          const ret: IPageDataViewModel = {
            ...d,

            contentVm: this.contentViewModel(arg, d.data.items)
          };
          return ret;
        })
      );
    }, { canRefresh: true, canAddNew: true, canGoBack: true });
  }

  /**
   * 
   * @param arg 
   * @param data
   * @returns 
   */
  private contentViewModel(arg: IBasePageOnInitArg, data: IViewData): IContentViewModel {
    // view model
    
    const vm: IContentViewModel = {
      data: { reservationPanel: data }, 
      
      chauffeurEmailVm: data && !data.unauthorized ? {
        data: data,
        rows: data.rows.map(r => ({ code: r[0], actionTitle: "", fields: r, actions: [ { code: 'edit', name: 'Edit' }, { code: 'delete', name: 'Delete' } ] })),
        rowsFiltered: data.rows.map(r => ({ code: r[0], actionTitle: "", fields: r, actions: [ { code: 'edit', name: 'Edit' }, { code: 'delete', name: 'Delete' } ] })),
        styleTypes: [],
        styleTypesFiltered: data.styleTypes,
        lastUpdateDateTime: formatDate(data.lastUpdateDateTime, 'MM/dd/yyyy HH:mm:ss', 'en-US'),
        showActionColumn: true
      } : null
    };
    
    return vm;
  }

  /**
   * 
   * @param pvm 
   * @param vm
   * @param tvm
   * @param arg 
   */
  rowActionInvoke(arg: IDataTableRowActionClickArg, vm: IContentViewModel, pvm: IPageViewModel) {
    
    const data = vm.data.reservationPanel.rows.find(i => i[0] == arg.rowCode);
    this.chauffeurEmailFormStart(data, pvm, arg.actionCode);
  }

  /**
   * 
   * @param vm 
   * @param searchVal 
   * @returns 
   */
  doDataSearch(vm: IContentViewModel, searchVal: string) {

    this.searchData = searchVal;
    if (searchVal.length === 0) {
      vm.chauffeurEmailVm.rowsFiltered = vm.chauffeurEmailVm.rows;
      return;
    }

    vm.chauffeurEmailVm.rowsFiltered = [];
    vm.chauffeurEmailVm.rows.forEach((r, i) => {
      let notFound: boolean = true;
      r.fields.forEach(c => {
        if (notFound && c.toLowerCase().indexOf(searchVal.toLowerCase()) > -1) {
          vm.chauffeurEmailVm.rowsFiltered.push(r);
          notFound = false;
        }
      });
    });
  }
}

/**
 * 
 */
interface IContentViewModel extends IPageContentViewModel {
  data?: { reservationPanel: IViewData }

  chauffeurEmailVm: IDataPanelViewModel;
}

/**
 * 
 */
interface IFormViewMomdel extends IPageContentFormViewModel {
  data: IFormDataMomdel;

  driverCodeVm: IFormInputViewModel;
  driverFirstNameVm: IFormInputViewModel;
  driverLastNameVm: IFormInputViewModel;
  emailInputVm: IFormInputViewModel;

  action: string;

  message: string;
}

/**
 * 
 */
interface IFormDataMomdel {
  driverCode: string;
  driverFirstName: string;
  driverLastName: string;
  emailAddress: string;
}

/**
 * 
 */
interface IChauffeurEmailItemData {
  data: IChauffeurEmailItem;

  emailAddress: string;

  actionType: {
    entityCode: string;
    actions: { code: string, name: string }[];
  }
}

/**
 * 
 */
interface IChauffeurEmailItem {
  
}